import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { promptService, PromptCreate } from '../services/promptService';

export const usePromptViewModel = () => {
  const queryClient = useQueryClient();

  const {
    data: prompts,
    isLoading,
    error,
    refetch,
  } = useQuery({
    queryKey: ['prompts'],
    queryFn: () => promptService.getList(true), // 비활성 포함
  });

  const createMutation = useMutation({
    mutationFn: promptService.create,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['prompts'] });
    },
  });

  const updateMutation = useMutation({
    mutationFn: ({ id, data }: { id: number; data: Partial<PromptCreate> }) =>
      promptService.update(id, data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['prompts'] });
    },
  });

  const deleteMutation = useMutation({
    mutationFn: promptService.delete,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['prompts'] });
    },
  });

  const setDefaultMutation = useMutation({
    mutationFn: promptService.setDefault,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['prompts'] });
    },
  });

  return {
    prompts: prompts ?? [],
    isLoading,
    error,
    refetch,
    createPrompt: createMutation.mutateAsync,
    isCreating: createMutation.isPending,
    updatePrompt: updateMutation.mutateAsync,
    isUpdating: updateMutation.isPending,
    deletePrompt: deleteMutation.mutateAsync,
    isDeleting: deleteMutation.isPending,
    setDefault: setDefaultMutation.mutateAsync,
    isSettingDefault: setDefaultMutation.isPending,
  };
};
